export default __webpack_public_path__ + "static/media/logo.bdde7d59.png";